import React from 'react';
import { t } from 'ttag';
import { ColourfulKitsData } from '../..';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import Kitty from '../../characters/Kitty';

const DebugGameOutro: React.FC<ISlide<ColourfulKitsData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: Kitty,
            text: t`Thanks ${data.name}. Now we know what is wrong with the kits, we need to fix them! So can you help with this one last thing?`,
            buttonText: t`Let's Go!`,
            buttonAction: nextSlide,
        },
    ];
    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default DebugGameOutro;
